module.exports = __webpack_public_path__ + "img/bullseye-pointer.e82b4b06.svg";